export function recallTimestamp(value) {
    if (value === null || value === undefined || value === "") return null;

    const numericValue = typeof value === "string" && value.trim() !== ""
        ? Number(value)
        : value;
    const timestamp = typeof numericValue === "number" && Number.isFinite(numericValue)
        ? numericValue
        : new Date(value).getTime();
    return Number.isFinite(timestamp) ? timestamp : null;
}

// The backend owns the learning steps. The client only keeps a card in the
// current session when the review response explicitly schedules another
// LEARNING step.
export function getNextLearningStep(card) {
    if (!card) return null;

    const learningState = card.learningState ?? card.learning_state;
    if (String(learningState).toUpperCase() !== "LEARNING") return null;

    const dueAt = recallTimestamp(card.nextRevisionDate ?? card.next_revision_date);
    return dueAt === null ? null : { card, dueAt };
}
